import { SocialIconImage } from './types';

export const SOCIAL_COLORS: Record<SocialIconImage, string> = {
  facebook: '#3B5998',
  instagram: '#E95950',
  linkedin: '#007BB5',
  twitter: '#55ACEE',
  youtube: '#FF0000',
};
